import logo from './logo.svg';
import './App.css';
import RankridgeCmsDashboard from './pages/home';
import NewPage from './components/newpage';
import { BrowserRouter as Router, Routes, Route, NavLink } from "react-router-dom";
import MyRichEditor from './components/myeditor';
import About from './components/about';
import UploadAsset from './components/UploadAsset';
import SeoPageEditor from './components/SeoPageEditor';
import SeoPagesCards from './components/SeoPagesCards';
import ImagesManager from './components/ImagesManager';
import PagesCards from './components/pagesmanage';
import SubPagesCards from './components/subpages';
import AcademicsManager from './components/AcademicsManager';
import PageDetailHub from './components/PageDetailHub';
import PageContentList from './components/PageContentList';
import SectionsList from './components/SectionsList';
import FaqsList from './components/FaqsList';
import BlogAdminList from './pages/BlogsList';
import Login from './pages/Login';
import LoginForm from './pages/users/userlogin';
import RegisterPage from './pages/users/register';
import ProtectedRoute from './pages/users/ProtectedRoute';
import SubpagesList from './components/SubpagesList';
function App() {
  return (
    <div className="App">


<Router>
<div className="min-h-screen flex flex-col bg-slate-50 dark:bg-slate-950">
{/* Navbar */}
<nav className="flex items-center gap-6 border-b border-slate-200 bg-white px-6 py-4 shadow-sm dark:border-slate-800 dark:bg-slate-900">
<NavLink
to="/"
end
className={({ isActive }) =>
`text-sm font-medium hover:text-emerald-600 ${
isActive ? "text-emerald-600" : "text-slate-600 dark:text-slate-300"
}`
}
>
Pages
</NavLink>

<NavLink
to="/sub-pages-list"
end
className={({ isActive }) =>
`text-sm font-medium hover:text-emerald-600 ${
isActive ? "text-emerald-600" : "text-slate-600 dark:text-slate-300"
}`
}
>
Sub Pages
</NavLink>

<NavLink
to="/page-content"
className={({ isActive }) =>
`text-sm font-medium hover:text-emerald-600 ${
isActive ? "text-emerald-600" : "text-slate-600 dark:text-slate-300"
}`
}
>
Page Content
</NavLink>


<NavLink
to="/images-list"
className={({ isActive }) =>
`text-sm font-medium hover:text-emerald-600 ${
isActive ? "text-emerald-600" : "text-slate-600 dark:text-slate-300"
}`
}
>
Images 
</NavLink>


<NavLink
to="/sections"
className={({ isActive }) =>
`text-sm font-medium hover:text-emerald-600 ${
isActive ? "text-emerald-600" : "text-slate-600 dark:text-slate-300"
}`
}
>
Sections 
</NavLink>



<NavLink
to="/seo-info-list"
className={({ isActive }) =>
`text-sm font-medium hover:text-emerald-600 ${
isActive ? "text-emerald-600" : "text-slate-600 dark:text-slate-300"
}`
}
>
SEO Info List
</NavLink>


<NavLink
to="/seo-info"
className={({ isActive }) =>
`text-sm font-medium hover:text-emerald-600 ${
isActive ? "text-emerald-600" : "text-slate-600 dark:text-slate-300"
}`
}
>
SEO New Content
</NavLink>


<NavLink
to="/acadamics-list"
className={({ isActive }) =>
`text-sm font-medium hover:text-emerald-600 ${
isActive ? "text-emerald-600" : "text-slate-600 dark:text-slate-300"
}`
}
>
Academics
</NavLink>


<NavLink
to="/faqs"
className={({ isActive }) =>
`text-sm font-medium hover:text-emerald-600 ${
isActive ? "text-emerald-600" : "text-slate-600 dark:text-slate-300"
}`
}
>
FAQS
</NavLink>



<NavLink
to="/blogs"
className={({ isActive }) =>
`text-sm font-medium hover:text-emerald-600 ${
isActive ? "text-emerald-600" : "text-slate-600 dark:text-slate-300"
}`
}
>
Blogs
</NavLink>

</nav>


{/* Routes */}
<main className="flex-1 p-6">
<Routes>
<Route path="/" element={ <SubPagesCards /> } />
<Route path="/new-page" element={<NewPage />} />
<Route path="/about" element={<About />} />
<Route path="/seo-info" element={<SeoPageEditor />} />
<Route path="/seo-info-list" element={<SeoPagesCards />} />
<Route path="/images-list" element={<ImagesManager />} />
<Route path="/acadamics-list" element={<AcademicsManager />} />
<Route path="/pages-list" element={<PagesCards />} />
<Route path="/sub-pages-list" element={<SubpagesList />} />

<Route path="/page-content" element={<PageContentList />} />
<Route path="/sections" element={<SectionsList />} />
<Route path="/faqs" element={<FaqsList />} />
<Route path="/blogs" element={<BlogAdminList />} />
<Route path="/login" element={<LoginForm />} />
<Route path="/register" element={<RegisterPage />} />


<Route path="/pages/:pageId" element={<PageDetailHub apiKey="12345678" />} />
<Route path="/pages/:pageId/sub/:subpageId" element={ <PageDetailHub apiKey="12345678" />} />
<Route path="/content" element={ <MyRichEditor
  uploadUrl="/api/upload.php"     // change to your endpoint
  initialHtml="<p>Start writing…</p>"
  onSave={(html) => console.log('SAVE', html)}  // replace with API call
/>} />

</Routes>
</main>
</div>
</Router>

      
    </div>
  );
}

export default App;
